import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

const accommodationsMessages = defineMessages({
  entityName: {
    id: "accommodation.entityName",
    defaultMessage: "Accommodations",
  },
  imagesHelpText: {
    id: "app.imagesHelpText",
    description: "Images Help Text",
    defaultMessage:
      "Las imágenes deben tener una resolución 1900 x 1080 pixeles y un tamaño máximo de 10MB.",
  },
  // New: Warning message for accommodations without images
  noImagesWarning: {
    id: "accommodation.noImagesWarning",
    defaultMessage: "Los siguientes alojamientos no tienen una imagen cargada: ",
    description: "Warning message for accommodations without images",
  },
  accommodationOccupancyConfiguration: {
    id: "accommodation.accommodationOccupancyConfiguration",
    defaultMessage: "Occupancy configuration",
  },
  accommodationBaseAdults: {
    id: "accommodation.accommodationBaseAdults",
    defaultMessage: "Base occupancy",
  },
  accommodationBaseAdultsInfo: {
    id: "accommodation.accommodationBaseAdultsInfo",
    defaultMessage:
      "Base occupancy in number of adults used for calculating the accommodation price.",
  },
  accommodationOccupancySelection: {
    id: "accommodation.accommodationOccupancySelection",
    defaultMessage: "Occupancy selection",
  },
  accommodationOccupancyGenerated: {
    id: "accommodation.accommodationOccupancyGenerated",
    defaultMessage: "Availables {current}/{max} occupation options.",
  },
  accommodationMaxOccupationTitle: {
    id: "accommodation.accommodationMaxOccupationTitle",
    defaultMessage: "Maximum occupancy",
  },
  accommodationMaxOccupationAdults: {
    id: "accommodation.accommodationMaxOccupationAdults",
    defaultMessage: "Adults",
  },
  accommodationMaxOccupationJuniors: {
    id: "accommodation.accommodationMaxOccupationJuniors",
    defaultMessage: "Juniors",
  },
  accommodationMaxOccupationChildren: {
    id: "accommodation.accommodationMaxOccupationChildren",
    defaultMessage: "Children",
  },
  accommodationMaxOccupationBabies: {
    id: "accommodation.accommodationMaxOccupationBabies",
    defaultMessage: "Babies",
  },
  accommodationOccupancyList: {
    id: "accommodation.accommodationOccupancyList",
    defaultMessage: "List",
  },
  maxCombinationParamsValidationFailed: {
    id: "accommodation.maxCombinationParamsValidationFailed",
    defaultMessage: "This field exceeds the maximum occupancy allowed ({max}).",
  },
  accommodationNoValidOccupancySelected: {
    id: "accommodation.accommodationNoValidOccupancySelected",
    defaultMessage:
      "None of the selected occupancies fit the new maximum occupancy. Select at least one before saving.",
  },
  accommodationOccupancyLoadFailed: {
    id: "accommodation.accommodationOccupancyLoadFailed",
    defaultMessage: "The occupancy options could not be loaded. Please try again.",
  },
});

const tableHeaderMessages = defineMessages({
  ticker: { id: "accommodation.ticker", defaultMessage: "Identifier" },
  translationsList: { id: "accommodation.name", defaultMessage: "Name" },
  description: { id: "accommodation.description", defaultMessage: "Description" },
});

const roomTypeMessages = defineMessages({
  roomDenominationTypeUnit: {
    id: "roomDenominationType.unit",
    defaultMessage: "Unit",
  },
  roomDenominationTypeRooms: {
    id: "roomDenominationType.rooms",
    defaultMessage: "Rooms",
  },
  roomDenominationTypeApartments: {
    id: "roomDenominationType.apartments",
    defaultMessage: "Apartments",
  },
  roomDenominationTypeBungalows: {
    id: "roomDenominationType.bungalows",
    defaultMessage: "Bungalows",
  },
  roomDenominationTypeCabins: {
    id: "roomDenominationType.cabins",
    defaultMessage: "Cabins",
  },
  roomDenominationTypeHouses: {
    id: "roomDenominationType.houses",
    defaultMessage: "Houses",
  },
  roomDenominationTypeShipCabin: {
    id: "roomDenominationType.shipCabin",
    defaultMessage: "Ship cabin",
  },
  roomDenominationTypeVillas: {
    id: "roomDenominationType.villas",
    defaultMessage: "Villas",
  },
  roomDenominationTypeBeds: {
    id: "roomDenominationType.beds",
    defaultMessage: "Beds",
  },
  roomDenominationTypePitches: {
    id: "roomDenominationType.pitches",
    defaultMessage: "Pitches",
  },
  roomDenominationTypeHolidayVillages: {
    id: "roomDenominationType.holidayVillages",
    defaultMessage: "Holiday villages",
  },
  roomDenominationTypeMobileHome: {
    id: "roomDenominationType.mobileHome",
    defaultMessage: "Mobile home",
  },
  roomDenominationTypeGlamping: {
    id: "roomDenominationType.glamping",
    defaultMessage: "Glamping",
  },
  roomDenominationTypeCaravans: {
    id: "roomDenominationType.caravans",
    defaultMessage: "Caravans",
  },
});

export const messages = {
  ...defaultCrudMessages,
  ...accommodationsMessages,
  ...roomTypeMessages,
  tableHeaders: tableHeaderMessages,
};
